import { RequestService } from "../../../../common/services/RequestService";
import { EDIT_FOOD_PRODUCT } from "./constants";

export const editFoodProductRequest = async (orderId, foodProductId, payload) => {
  const response = await RequestService.put(
    EDIT_FOOD_PRODUCT.replace("{order_id}", orderId).replace(
      "{food_product_list_id}",
      foodProductId
    ),
    payload
  );
  return response;
};
